module.exports = __webpack_public_path__ + "img/bar-logo.1f43209b.png";